import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ModelHelpers } from '../../../models/ModelHelpers';
import { PSAcuerdoPosteriorModel } from '../../../models/ps-acuerdo-posterior-model';
import { PsAcuerdoPosteriorService } from '../../../services/ps-acuerdo-posterior.service';
import { DateHelper } from '../../../models/NgDateCustomAdapter';

@Component({
  selector: 'app-ps-acuerdo-posterior-edit',
  templateUrl: './ps-acuerdo-posterior-edit.component.html',
  styleUrls: ['./ps-acuerdo-posterior-edit.component.scss']
})
export class PsAcuerdoPosteriorEditComponent implements OnInit {

  acuerdosFormArray: FormArray;
  acuerdo: PSAcuerdoPosteriorModel = new PSAcuerdoPosteriorModel();
  @Input() idPs: number = 0;
  tiposAcuerdoList: any;
  form: FormGroup;
  errorMessage: string = '';

  customFieldNamesError = {
    tipo: 'tipo'
  };

  constructor(private _fb: FormBuilder, private _psAcuerdoPosteriorService: PsAcuerdoPosteriorService,
    @Optional() public dialogRef: MatDialogRef<PsAcuerdoPosteriorEditComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dateHelper: DateHelper) {
    this.acuerdosFormArray = this._fb.array([]);

    if (data !== undefined) {
      this.idPs = data.idPs
    }
  }

  ngOnInit() {
    this.createForm();
    this.loadData();
  }

  createForm() {
    //Creamos el formulario
    this.form = this._fb.group({
      idPs: [this.idPs],
      tipo: ['', Validators.required],
      fecha: [this.dateHelper.dateFormat_iso(new Date())],
      detalle: [''],
      interlocutorCliente: [''],
      interlocutorValtecsa: [''],
    });
  }

  loadData() {
    this._psAcuerdoPosteriorService.getTipoAcuerdoPosteriorList().subscribe(data => this.tiposAcuerdoList = data);
  }

  save() {
    this.errorMessage = null;
    ModelHelpers.copyFromForm(this.form.value, this.acuerdo);

    if (!this.form.valid) {
      console.log(this.form.errors);
      this.errorMessage = ModelHelpers.getFormValidationErrors(this.form, this.customFieldNamesError);
      // this.errorMessage = 'Error de validación';
      return;
    }

    this._psAcuerdoPosteriorService.post(this.acuerdo)
      .subscribe((data: any) => {
        if (data.correct === false) {
          this.errorMessage = data.mensaje;
          return;
        } else {
          this.closeDialog(true)
        }
      }, err => {
        console.error(err)
        this.errorMessage = err;
      }
      );
  }

  closeDialog(ret: boolean) {
    this.dialogRef.close(ret);
  }

}
